import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const LogoutButton = () => (
  <a href="/auth/logout">
    <Button basic floated="right">
      Sair
    </Button>
  </a>
);

export default LogoutButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/LogoutButton.js